import {useTranslation} from 'react-i18next'

import {SlideshowThumbnail} from './Slideshow.Thumbnail'
import {useSlideshowContext} from '../'

export const SlideshowThumbnails = () => {
  const {items} = useSlideshowContext()
  const {t} = useTranslation()

  return (
    <nav
      className={'hide-scrollbar relative hidden max-w-[458px] shrink gap-spacing-12 overflow-auto md:flex'}
      aria-label={t('common:slideshow.thumbnailNavigationLabel')}
    >
      {items.map((_, index) => (
        <SlideshowThumbnail
          key={index}
          index={index}
        />
      ))}
    </nav>
  )
}
